<template>
  <!-- Theme Settings -->
  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="theme-settings-offcanvas"
  >
    <div class="d-flex align-items-center bg-primary p-3 offcanvas-header">
      <h5 class="text-white m-0">Theme Settings</h5>
      <button
        type="button"
        class="btn-close btn-close-white ms-auto"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>

    <div class="offcanvas-body p-0">
      <div data-simplebar class="h-100">
        <div class="p-3">
          <h5 class="mb-3 fs-16 fw-bold">Color Scheme</h5>

          <div class="row">
            <div class="col-4">
              <div class="form-check form-switch card-switch mb-1">
                <input
                  class="form-check-input"
                  type="checkbox"
                  name="data-bs-theme"
                  id="layout-color-light"
                  value="light"
                />
                <label class="form-check-label" for="layout-color-light">
                  <!-- <img
                    src="../assets/images/layouts/light.png"
                    alt=""
                    class="img-fluid"
                  /> -->
                </label>
              </div>
              <h5 class="font-14 text-center text-muted mt-2">Light</h5>
            </div>

            <div class="col-4">
              <div class="form-check form-switch card-switch mb-1">
                <input
                  class="form-check-input"
                  type="checkbox"
                  name="data-bs-theme"
                  id="layout-color-dark"
                  value="dark"
                />
                <label class="form-check-label" for="layout-color-dark">
                  <!-- <img
                    src="../assets/images/layouts/dark.png"
                    alt=""
                    class="img-fluid"
                  /> -->
                </label>
              </div>
              <h5 class="font-14 text-center text-muted mt-2">Dark</h5>
            </div>
          </div>

          <div id="layout-width">
            <h5 class="my-3 fs-16 fw-bold">Layout Mode</h5>

            <div class="row">
              <div class="col-4">
                <div class="form-check form-switch card-switch mb-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="data-layout-mode"
                    id="layout-mode-fluid"
                    value="fluid"
                  />
                  <label class="form-check-label" for="layout-mode-fluid">
                    <!-- <img
                      src="../assets/images/layouts/light.png"
                      alt=""
                      class="img-fluid"
                    /> -->
                  </label>
                </div>
                <h5 class="font-14 text-center text-muted mt-2">Fluid</h5>
              </div>

              <div class="col-4">
                <div id="layout-boxed">
                  <div class="form-check form-switch card-switch mb-1">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      name="data-layout-mode"
                      id="layout-mode-boxed"
                      value="boxed"
                    />
                    <label class="form-check-label" for="layout-mode-boxed">
                      <!-- <img
                        src="../assets/images/layouts/boxed.png"
                        alt=""
                        class="img-fluid"
                      /> -->
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Boxed</h5>
                </div>
              </div>
            </div>
          </div>

          <h5 class="my-3 fs-16 fw-bold">Topbar Color</h5>

          <div class="row">
            <div class="col-4">
              <div class="form-check form-switch card-switch mb-1">
                <input
                  class="form-check-input"
                  type="checkbox"
                  name="data-topbar-color"
                  id="topbar-color-light"
                  value="light"
                />
                <label class="form-check-label" for="topbar-color-light">
                  <!-- <img
                    src="../assets/images/layouts/light.png"
                    alt=""
                    class="img-fluid"
                  /> -->
                </label>
              </div>
              <h5 class="font-14 text-center text-muted mt-2">Light</h5>
            </div>

            <div class="col-4">
              <div class="form-check form-switch card-switch mb-1">
                <input
                  class="form-check-input"
                  type="checkbox"
                  name="data-topbar-color"
                  id="topbar-color-dark"
                  value="dark"
                />
                <label class="form-check-label" for="topbar-color-dark">
                  <!-- <img
                    src="../assets/images/layouts/topbar-dark.png"
                    alt=""
                    class="img-fluid"
                  /> -->
                </label>
              </div>
              <h5 class="font-14 text-center text-muted mt-2">Dark</h5>
            </div>
          </div>

          <div>
            <h5 class="my-3 fs-16 fw-bold">Menu Color</h5>

            <div class="row">
              <div class="col-4">
                <div class="form-check form-switch card-switch mb-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="data-menu-color"
                    id="leftbar-color-light"
                    value="light"
                  />
                  <label class="form-check-label" for="leftbar-color-light">
                    <!-- <img
                      src="../assets/images/layouts/sidebar-light.png"
                      alt=""
                      class="img-fluid"
                    /> -->
                  </label>
                </div>
                <h5 class="font-14 text-center text-muted mt-2">Light</h5>
              </div>

              <div class="col-4">
                <div class="form-check form-switch card-switch mb-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="data-menu-color"
                    id="leftbar-color-dark"
                    value="dark"
                  />
                  <label class="form-check-label" for="leftbar-color-dark">
                    <!-- <img
                      src="../assets/images/layouts/light.png"
                      alt=""
                      class="img-fluid"
                    /> -->
                  </label>
                </div>
                <h5 class="font-14 text-center text-muted mt-2">Dark</h5>
              </div>
            </div>
          </div>

          <div id="sidebar-size">
            <h5 class="my-3 fs-16 fw-bold">Sidebar Size</h5>

            <div class="row">
              <div class="col-4">
                <div class="form-check form-switch card-switch mb-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="data-sidenav-size"
                    id="leftbar-size-default"
                    value="default"
                  />
                  <label class="form-check-label" for="leftbar-size-default">
                    <!-- <img
                      src="../assets/images/layouts/light.png"
                      alt=""
                      class="img-fluid"
                    /> -->
                  </label>
                </div>
                <h5 class="font-14 text-center text-muted mt-2">Default</h5>
              </div>

              <div class="col-4">
                <div class="form-check form-switch card-switch mb-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="data-sidenav-size"
                    id="leftbar-size-compact"
                    value="compact"
                  />
                  <label class="form-check-label" for="leftbar-size-compact">
                    <!-- <img
                      src="../assets/images/layouts/compact.png"
                      alt=""
                      class="img-fluid"
                    /> -->
                  </label>
                </div>
                <h5 class="font-14 text-center text-muted mt-2">Compact</h5>
              </div>

              <div class="col-4">
                <div class="form-check form-switch card-switch mb-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="data-sidenav-size"
                    id="leftbar-size-small"
                    value="condensed"
                  />
                  <label class="form-check-label" for="leftbar-size-small">
                    <!-- <img
                      src="../assets/images/layouts/sm.png"
                      alt=""
                      class="img-fluid"
                    /> -->
                  </label>
                </div>
                <h5 class="font-14 text-center text-muted mt-2">Condensed</h5>
              </div>

              <div class="col-4">
                <div class="form-check form-switch card-switch mb-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="data-sidenav-size"
                    id="leftbar-size-full"
                    value="full"
                  />
                  <label class="form-check-label" for="leftbar-size-full">
                    <!-- <img
                      src="../assets/images/layouts/full.png"
                      alt=""
                      class="img-fluid"
                    /> -->
                  </label>
                </div>
                <h5 class="font-14 text-center text-muted mt-2">Full Layout</h5>
              </div>
            </div>
          </div>

          <div id="layout-position">
            <h5 class="my-3 fs-16 fw-bold">Layout Position</h5>

            <div class="btn-group checkbox" role="group">
              <input
                type="radio"
                class="btn-check"
                name="data-layout-position"
                id="layout-position-fixed"
                value="fixed"
              />
              <label
                class="btn btn-soft-primary w-sm"
                for="layout-position-fixed"
                >Fixed</label
              >

              <input
                type="radio"
                class="btn-check"
                name="data-layout-position"
                id="layout-position-scrollable"
                value="scrollable"
              />
              <label
                class="btn btn-soft-primary w-sm ms-0"
                for="layout-position-scrollable"
                >Scrollable</label
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="offcanvas-footer border-top p-3 text-center">
      <div class="row">
        <div class="col-6">
          <button type="button" class="btn btn-light w-100" id="reset-layout">
            Reset
          </button>
        </div>
        <div class="col-6">
          <a
            href="https://1.envato.market/velonic"
            target="_blank"
            role="button"
            class="btn btn-primary w-100"
            >Buy Now</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

